import { useMemo } from "react";
import { useMessageStore } from "@/app/store/message";

export default function useClientMessageList() {
  // ✅ 直接使用 Zustand 的 selector，自动订阅状态变化
  const historyMsgList = useMessageStore((state) => state.historyMsgList);
  const msgList = useMessageStore((state) => state.msgList);

  // 使用 useMemo 计算派生状态，避免不必要的重新计算
  const messages = useMemo(() => {
    return [...historyMsgList, ...msgList].filter((item) => !item.hide);
  }, [historyMsgList, msgList]);

  const newMessageList = msgList;

  return {
    messages,
    newMessageList,
  };
}
